var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "el-section" },
    [
      _vm.alert.show
        ? _c("invite-alert", {
            staticClass: "eu-no-padding",
            attrs: { alert: _vm.alert },
            on: {
              cancel: function ($event) {
                _vm.alert.show = false
              },
            },
          })
        : _vm._e(),
      _vm.loadingDetail
        ? _c(
            "div",
            { staticClass: "eu-pa_6 eu-align_center" },
            [_c("emd-loader", { attrs: { type: "_invert" } })],
            1
          )
        : _c(
            "emd-card",
            { staticClass: "_highlight_header _footer_end" },
            [
              _c(
                "emd-card-header",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "actions",
                      fn: function () {
                        return [
                          _vm.showActionsButton
                            ? _c(
                                "div",
                                {
                                  staticClass: "emd-dropdown _position_right",
                                  attrs: { id: "jsDropdown" },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "emd-dropdown__trigger" },
                                    [
                                      _c(
                                        "emd-button",
                                        {
                                          attrs: {
                                            color: "primary",
                                            size: "small",
                                          },
                                          on: { click: _vm.toogleDropdown },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("team.actions.title")
                                            ) + " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "emd-dropdown__content",
                                      class: {
                                        _active: _vm.showActionsDropdown,
                                      },
                                    },
                                    [
                                      _c(
                                        "nav",
                                        {
                                          staticClass:
                                            "emd-nav-list _direction_column _hoverble",
                                        },
                                        [
                                          _c("ul", [
                                            _vm.canEditEnable
                                              ? _c(
                                                  "li",
                                                  {
                                                    staticClass:
                                                      "emd-nav-list__item eu-no-margin",
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.toggleEdit = true
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "emd-button",
                                                      {
                                                        staticClass: "eu-pa_3",
                                                        attrs: {
                                                          color: "primary",
                                                          type: "link",
                                                        },
                                                      },
                                                      [
                                                        _c("span", {
                                                          staticClass:
                                                            "uil uil-pen",
                                                        }),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "team.actions.edit"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm.canRemoveEnable
                                              ? _c(
                                                  "li",
                                                  {
                                                    staticClass:
                                                      "emd-nav-list__item eu-no-margin",
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.modalOpenned = true
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "emd-button",
                                                      {
                                                        staticClass: "eu-pa_3",
                                                        attrs: {
                                                          color: "danger",
                                                          type: "link",
                                                        },
                                                      },
                                                      [
                                                        _c("span", {
                                                          staticClass:
                                                            "uil uil-times-circle",
                                                        }),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "team.actions.remove-permission"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("emd-text", { attrs: { size: "section", tag: "h2" } }, [
                    _vm._v(" " + _vm._s(_vm.$t("team.user_info")) + " "),
                  ]),
                ],
                1
              ),
              _c(
                "emd-card-content",
                { attrs: { customClass: "eu-pa_3" } },
                [
                  _c("user-personal-data", { attrs: { user: _vm.user } }),
                  _c("user-form-update", {
                    attrs: {
                      editing: _vm.toggleEdit,
                      loading: _vm.loadingEdit,
                      user: _vm.user,
                    },
                    on: {
                      cancelEditing: function ($event) {
                        _vm.toggleEdit = false
                      },
                      getUser: _vm.getUser,
                      setAlert: _vm.setAlert,
                      resetAlert: _vm.resetAlert,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
      _vm.modalOpenned
        ? _c("modal-password", {
            attrs: { callback: _vm.removePermission },
            on: {
              cancel: function ($event) {
                _vm.modalOpenned = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }